const IMGIX_SOURCES = [
  {
    oc_prefix: 'https://user.oc-static.com/',
    imgix_url: 'https://oc-user.imgix.net/',
  },
  {
    oc_prefix: '//user.oc-static.com/',
    imgix_url: 'https://oc-user.imgix.net/',
  },
  {
    oc_prefix: 'https://course.oc-static.com/',
    imgix_url: 'https://oc-course.imgix.net/',
  },
  {
    oc_prefix: 'https://s3-eu-west-1.amazonaws.com/course.oc-static.com/',
    imgix_url: 'https://oc-course.imgix.net/',
  },
  {
    oc_prefix: 'https://sdz-upload.s3.amazonaws.com/',
    imgix_url: 'https://oc-upload.imgix.net/',
  },
  {
    oc_prefix: '//sdz-upload.s3.amazonaws.com/',
    imgix_url: 'https://oc-upload.imgix.net/',
  },
  {
    oc_prefix: 'https://s3-eu-west-1.amazonaws.com/sdz-upload/',
    imgix_url: 'https://oc-upload.imgix.net/',
  },
  {
    oc_prefix: '//s3-eu-west-1.amazonaws.com/sdz-upload/',
    imgix_url: 'https://oc-upload.imgix.net/',
  },
  {
    oc_prefix: 'https://static.oc-static.com/',
    imgix_url: 'https://oc-static.imgix.net/',
  },
  {
    oc_prefix: '//static.oc-static.com/',
    imgix_url: 'https://oc-static.imgix.net/',
  },
  {
    oc_prefix: '/bundles/',
    imgix_url: 'https://oc-bundles-images.imgix.net/',
  },
  {
    oc_prefix: '/images/',
    imgix_url: 'https://oc-images.imgix.net/',
  },
  {
    oc_prefix: 'https://openclassrooms.com/',
    imgix_url: 'https://oc-assets.imgix.net/',
  },
];

function getImgixSource(baseUrl) {
  let imgixSource = '';

  IMGIX_SOURCES.some((source) => {
    const prefixLength = source.oc_prefix.length;
    const matchOcPrefix = baseUrl.substr(0, prefixLength) === source.oc_prefix;

    if (!matchOcPrefix) {
      return false;
    }

    imgixSource = source.imgix_url + baseUrl.substr(prefixLength);

    return true;
  });

  return imgixSource;
}

export default function getUrl(src, width = 0, height = 0) {
  const imgixSource = getImgixSource(src);
  const isSvg = src.endsWith('.svg');

  if (!imgixSource || isSvg) {
    return src;
  }

  const paramsSeparator = imgixSource.indexOf('?') === -1 ? '?' : '&';

  let url = `${imgixSource}${paramsSeparator}auto=compress,format&q=80`;

  if (width) {
    url += `&w=${width}`;
  }

  if (height) {
    url += `&h=${height}`;
  }

  return `${url}`;
}
